import numeral from "numeral";
const NumberUtils = {
  JAVA_INTEGER_MIN_VALUE: 2 ** 31 * -1,
  JAVA_INTEGER_MAX_VALUE: 2 ** 31 - 1,
  BYTES_PER_GB: 1e9,
  BYTES_PER_GIB: 1073741824,
  normalizeNumber(number) {
    switch (number) {
      case "NaN":
        return NaN;
      case "Infinity":
        return Number.MAX_VALUE;
      case "-Infinity":
        return Number.MIN_VALUE;
      default:
        return Number(number);
    }
  },
  normalizeGraphNumber(number) {
    switch (number) {
      case "NaN":
      case "Infinity":
      case "-Infinity":
        return 0;
      default:
        return Number(number);
    }
  },
  formatNumber(number) {
    try {
      return numeral(this.normalizeNumber(number)).format("0,0.[000000000]");
    } catch (_e) {
      return String(number);
    }
  },
  formatPercentage(percentage) {
    try {
      return numeral(this.normalizeNumber(percentage)).format("0.00%");
    } catch (_e) {
      return String(percentage);
    }
  },
  formatBytes(number) {
    numeral.zeroFormat("0B");
    let formattedNumber;
    try {
      formattedNumber = numeral(this.normalizeNumber(number)).format("0.0ib");
    } catch (_e) {
      formattedNumber = String(number);
    }
    numeral.zeroFormat(null);
    return formattedNumber;
  },
  formatDecimalBytes(number) {
    numeral.zeroFormat("0B");
    let formattedNumber;
    try {
      formattedNumber = numeral(this.normalizeNumber(number)).format("0.0b");
    } catch (_e) {
      formattedNumber = String(number);
    }
    numeral.zeroFormat(null);
    return formattedNumber;
  },
  bytesToGb(bytes) {
    return parseFloat((bytes / this.BYTES_PER_GB).toFixed(2));
  },
  gbToBytes(gb) {
    return Math.round(gb * this.BYTES_PER_GB);
  },
  bytesToGiB(bytes) {
    return parseFloat((bytes / this.BYTES_PER_GIB).toFixed(2));
  },
  giBToBytes(giB) {
    return Math.round(giB * this.BYTES_PER_GIB);
  },
  isNumber(possibleNumber) {
    return possibleNumber !== "" && !Number.isNaN(Number(possibleNumber));
  }
};
export default NumberUtils;
